// Timestamps from the backend are naive UTC (no 'Z' suffix). Parsing them
// with new Date() treats them as LOCAL time, showing times 2h behind SAST.
// parseUTCDate appends 'Z' when the string lacks timezone info so the
// browser correctly converts UTC -> viewer's local time (SAST for the club).
export const parseUTCDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value === 'string' && value.includes('T') && !/(Z|[+-]\d{2}:?\d{2})$/.test(value)) {
    return new Date(value + 'Z');
  }
  return new Date(value);
};
